import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n
} from "@/composables/useI18n";

import {
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import type {
  Customer,
} from "@/components/customers/scripts/types";

import VueI18n from "vue-i18n";

import {
  maximumPercentageDecimalCount,
  maxPercentage,
  minPercentage,
} from "@/scripts/Common/constraints/constraints";

import {
  maxCountPointsOfSales,
  maximumTaxNumberLength,
  maximumVatIdentificationLength,
  minCountPointsOfSales,
} from "@/components/customers/scripts/constraints";

import {
  isStringAndHasValue,
  hasValidDecimals,
  isBiggerOrEqualTo,
  isRequired,
  isSmallerOrEqualTo,
  isSmallerOrEqualToMaxLength,
  isNullOrUndefined
} from "@/scripts/Common/validators/defaultValidator";

import {
  useCustomerStateMap,
} from "@/components/customers/composables/useCustomerStateMap";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountingDataEdit',
  props: {
  label: {
    required: true,
    type: String as PropType<string | VueI18n.TranslateResult>,
  },
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  model: {
    required: true,
    type: Object as PropType<Customer>,
  },
  defaultProvision: {
    required: false,
    type: Number as PropType<number>,
    default: 0
  },
  expanded: {
    required: false,
    type: Array as PropType<number[]>,
    default() {
      return [1]
    }
  },
},
  emits: [
  'onValidChange'
],
  setup(__props, { emit: emits }) {

const props = __props;


const {
  t,
} = useI18n();

const {customerStateMap} = useCustomerStateMap();





const valid = ref(true);
const accountingDataForm = ref();

const internalExpand = ref(props.expanded)

const isNotDefaultProvision = ref(false);

const validate = () => {
  accountingDataForm.value.validate();
}
watch(valid, () => {
  validate();
  emits('onValidChange', unref(valid))
})

watch(() => props.expanded, () => {
  internalExpand.value = props.expanded
})

watch(() => props.model?.provision, () => {
  const currentProvision = Number.parseFloat(props.model?.provision);

  isNotDefaultProvision.value = Number.isNaN(currentProvision)
    ? true
    : currentProvision !== props.defaultProvision;
})

return { __sfc: true,t, customerStateMap, props, emits, valid, accountingDataForm, internalExpand, isNotDefaultProvision, validate, maximumPercentageDecimalCount, maxPercentage, minPercentage, maxCountPointsOfSales, maximumTaxNumberLength, maximumVatIdentificationLength, minCountPointsOfSales, isStringAndHasValue, hasValidDecimals, isBiggerOrEqualTo, isRequired, isSmallerOrEqualTo, isSmallerOrEqualToMaxLength, isNullOrUndefined }
}

})